import { EDeleteAllNotificationActionTypes, TDeleteAllNotificationsFailed } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const deleteAllFailed: () => TDeleteAllNotificationsFailed =
  actionGenerator<EDeleteAllNotificationActionTypes.Failed>(EDeleteAllNotificationActionTypes.Failed);
